var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC5840",
    d: "M15.55 8A7.455 7.455 0 10.64 8a7.455 7.455 0 0014.91 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.103 11.44c.19 0 .348.07.474.21.128.14.19.322.19.544 0 .21-.062.386-.19.523a.61.61 0 01-.474.207.64.64 0 01-.488-.207.73.73 0 01-.194-.523.78.78 0 01.2-.54.66.66 0 01.49-.215zm.48-1.08h-.96l-.21-6.63h1.38l-.21 6.63z"
  }))));
}
export default SvgExclamationIcon;